var EMAIL_REGEX = new RegExp('^[a-zA-Z0-9_!#$%&’*+/=?`{|}~^.-]+@[a-zA-Z0-9.-]+$');

/**
 * Utility methods for Emails.
 *
 * @class emailUtils
 * @static
 */
module.exports = {

  EMAIL_REGEX: EMAIL_REGEX,

  /**
   * Verify a String with email format
   * @param email {String} the value to verify.
   * @return {Boolean} true if it's in email format, otherwise false.
   */
  isEmailFormat: function(email){
    return EMAIL_REGEX.test(email);
  }
};
